import { useEffect } from 'react';

import { applySeoMeta, type SeoMeta } from './head';

/**
 * Apply a route's SEO head state. Pass `null` while the route's data is not
 * ready yet (e.g. DealPage loading) — the previous head is kept untouched so
 * crawlers and the tab title never flash a half-built state.
 *
 * The meta is serialized so callers can pass inline object literals: the
 * effect re-runs on CONTENT change, not on referential identity.
 */
export function useSeoHead(meta: SeoMeta | null): void {
  const serialized = meta === null ? null : JSON.stringify(meta);
  useEffect(() => {
    if (serialized !== null) applySeoMeta(JSON.parse(serialized) as SeoMeta);
  }, [serialized]);
}
